import { PHONE_REGEX } from 'gcs-common/constants/formValidation';
import { parsePhoneOrEmail } from 'gcs-common/helper/formHelper';
import * as Yup from 'yup';

export const stringValidator = Yup.string()
  .min(2, 'Mindestens 2 Zeichen erforderlich')
  .max(50, 'Maximal 50 Zeichen möglich')
  .required('Erforderlich');

export const idValidator = Yup.string().uuid('Ungültige ID (Format: 00000000-0000-0000-0000-000000000000)').nullable();

export const idValidatorRequired = idValidator.required('Erforderlich');

export const houseNumbersValidator = Yup.array()
  .nullable()
  .test('Valid house number', 'Hausnummer muss aus genau drei Ziffern bestehen.', (houseNumbers) => {
    if (houseNumbers) {
      return (
        houseNumbers.every((houseNumber) => houseNumber.length === 3) &&
        houseNumbers.every((houseNumber) => houseNumber.match(/^[0-9]+$/))
      );
    }
    return true;
  })
  .required('Erforderlich');

export const ldaNumbersValidator = Yup.array()
  .nullable()
  .test('Valid LDA numbers', 'LDA muss aus genau drei Ziffern bestehen.', (ldaNumbers) => {
    if (ldaNumbers) {
      return (
        ldaNumbers.every((ldaNumber) => ldaNumber.length === 3) &&
        ldaNumbers.every((ldaNumber) => ldaNumber.match(/^[0-9]+$/))
      );
    }
    return true;
  })
  .required('Erforderlich');

export const ldaNumberValidator = Yup.string()
  .nullable()
  .test('Valid LDA numbers', 'LDA muss aus genau drei Ziffern bestehen.', (ldaNumber) => {
    if (ldaNumber) {
      return ldaNumber.length === 3 && ldaNumber.match(/^[0-9]+$/);
    }
    return true;
  })
  .required('Erforderlich');

export const validatorRequired = Yup.string().required('Erforderlich');

/**
 * Optional phone number, validated like the phone part of phoneOrEmailValidator; emails are rejected.
 * allowedValue: an existing value accepted as-is, e.g. a number provisioned from AD
 */
export const getPhoneNumberValidator = (allowedValue) =>
  Yup.string().test('Valid phone number', 'Ungültige Telefonnummer (z. B. +49 170 1234567)', (value) => {
    if (!value?.trim() || value === allowedValue) return true;
    const parsed = parsePhoneOrEmail(value);
    return 'phoneNumber' in parsed && PHONE_REGEX.test(parsed.phoneNumber);
  });

/**
 * Required email or phone number; phone numbers are valid if they can be normalized to E.164.
 */
export const phoneOrEmailValidator = Yup.string()
  .trim()
  .nullable()
  .required('Erforderlich')
  .test('Valid phone number or email', 'Bitte gib eine gültige Mobilnummer oder E-Mail-Adresse ein.', (value) => {
    if (!value) return true;
    const parsed = parsePhoneOrEmail(value);
    return 'email' in parsed || PHONE_REGEX.test(parsed.phoneNumber);
  });
